import React, { useState } from 'react'
import DatePicker from 'react-datepicker'
import DateInput from './date-input'
import GamesFilter from './games-filter'
import SelectGames from './select-games'
import Cancelled from './cancelled'
import PlayersSarch from './players-search'
import DatePanel from './date-panel'

export default function TopPanel(props) {
  const { summary, date, onDateChange, archiveStart } = props
  const [showSummary, setShowSummary] = useState(false)
  const inArchive = moment(archiveStart) >= moment(date)

  return <div className='panel-body'>
    <div className='row top-line-container'>
      <div className='col-lg-2 col-xs-4'>
        { !inArchive &&
          <button className='btn btn-success' onClick={(e) => {e.target.blur(); props.onNewGame({type: 'new'})}}>
            <i className='fa fa-plus'></i>&nbsp;&nbsp;New Event
          </button>
        }
      </div>
      <div className='col-lg-7 col-xs-5'>
        <div className={'day-summary-items' + (showSummary ? '' : ' hidden')}>
          <div className='summary-item'><span>Total Events: <b>{summary.total_events || 0}</b></span></div>
          <div className='summary-item'><span>Total Hours: <b>{summary.total_hours || 0}</b></span></div>
          <div className='summary-item'><span>Total Players: <b>{summary.total_players || 0}</b></span></div>
          <div className='summary-item'><span>Cancelled Events: <b>{summary.cancelled_events || 0}</b></span></div>
        </div>
      </div>
      <div className='col-xs-2 col-lg-1 text-right summary-eye'>
        <a
          className={'day-summary-switcher clickable text-right' + (showSummary ? '' : ' collapsed')}
          onClick={() => setShowSummary(!showSummary)}
        >
          <div className='open-games-eye'></div>
        </a>
      </div>
      <div className='col-lg-2 col-xs-12 player-search'>
        <PlayersSarch onQuery={props.onQuery} />
      </div>
    </div>

    <div className='row top-line-container'>
      <div className='panel-body'>
        <div className='form-group'>
          <div className='fc-toolbar fc-header-toolbar'>
            <div className='col-lg-3 desktop-only left-toolbar-container'>
              <DatePanel date={date} onDateChange={onDateChange} />
              { !inArchive &&
                <button
                  className={'upcoming-games-button' + (props.showUpcoming ? ' active' : '')}
                  onClick={props.onUpcoming}>
                    <span>Upcoming Games</span>
                </button>
              }
            </div>
            <div className='col-lg-5 centered'>
              { !props.showUpcoming &&
                <div className='fc-center'>
                  <DatePicker
                    customInput={<DateInput />}
                    selected={moment(date)}
                    onChange={(newDate) => onDateChange(newDate)}
                  />
                </div>
              }
            </div>
            <div className='col-lg-4'>
              <div className='right-container'>
                { !inArchive && <SelectGames onGamesSelect={props.onGamesSelect} gamesSelector={props.gamesSelector} /> }
                <GamesFilter filter={props.filter} setFilter={props.setFilter} />
                <Cancelled cancelled={props.cancelled} onCancelled={props.onCancelled} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
